export const link = [
    {
        id: 1,
        name: "Սյունիքի մարզ",
        info: "https://www.youtube.com/watch?v=ddC2i_saORo",
        menuItemId: 6
    },
    {
        id: 2,
        name: "Շիրակի մարզ",
        info: "https://www.youtube.com/watch?v=_DoJv3bbqe4",
        menuItemId: 6
    },
    {
        id: 3,
        name: "Վյոց Ձորի մարզ",
        info: "https://www.youtube.com/watch?v=IcxfiOZR6G4",
        menuItemId: 6
    },
    {
        id: 4,
        name: "Արմավիրի մարզ",
        info: "https://www.youtube.com/watch?v=9l9Q7OfyLGg",
        menuItemId: 6
    },
    {
        id: 5,
        name: "Կոտայքի մարզ",
        info: "https://www.youtube.com/watch?v=gTCtvI6vLR8",
        menuItemId: 6
    },
    {
        id: 6,
        name: "Տավուշի մարզ",
        info: "https://www.youtube.com/watch?v=_f8kzJMDqPE",
        menuItemId: 6
    },
    {
        id: 7,
        name: "Արարատի մարզ",
        info: "https://www.youtube.com/watch?v=ym2ocAcwUPw",
        menuItemId: 6
    },
    {
        id: 8,
        name: "Արագածոտնի մարզ",
        info: "https://www.youtube.com/watch?v=cUCtMHnw6Y0",
        menuItemId: 6
    },
    {
        id: 9,
        name: "Լոռու մարզ",
        info: "https://www.youtube.com/watch?v=NcY4MIjOIog",
        menuItemId: 6
    },
    {
        id: 10,
        name: "Գեղարքունիքի մարզ",
        info: "https://www.youtube.com/watch?v=_S3ntImaWnw",
        menuItemId: 6
    },
    {
        id: 11,
        name: "ՀՀ տրանսպորտ",
        info: "https://www.youtube.com/watch?v=27xIxNuRMqQ",
        menuItemId: 6
    },
    {
        id: 12,
        name: "ՀՀ–ն աշխատանքի միջազգային բաժանման համակարգում, արտաքին տնտ. կապեր",
        info: "https://www.youtube.com/watch?v=LKZ_OJVkTR0",
        menuItemId: 6
    },
    {
        id: 13,
        name: "ՀՀ երկրաբանական կառուցվածքը",
        info: "https://www.youtube.com/watch?v=vc4G_l9-dAo",
        menuItemId: 6
    },
    {
        id: 14,
        name: "ՀՀ սպասարկման ոլորտ",
        info: "https://www.youtube.com/watch?v=bU0IC3X04qQ",
        menuItemId: 6
    },
    {
        id: 15,
        name: "Հնդկաստան",
        info: "https://www.youtube.com/watch?v=RIJeVaTzpA4",
        menuItemId: 6
    },
    {
        id: 16,
        name: "Ճապոնիա",
        info: "https://www.youtube.com/watch?v=ECqa-hjvBzs",
        menuItemId: 6
    },
    {
        id: 17,
        name: "Հարավաֆրիկյան հանրապետություն",
        info: "https://www.youtube.com/watch?v=NIgWiD6jZuk",
        menuItemId: 6
    },
    {
        id: 18,
        name: "ԱՄՆ",
        info: "https://www.youtube.com/watch?v=RhYiy6QyIyo",
        menuItemId: 6
    }
];
